module.exports = __webpack_public_path__ + "img/8-threeImg.950bc0f4.png";